export async function searchApi(searchText, pageType, country, theme) {
  try {
    const url = theme =="light"
      ? `${process.env.NEXT_PUBLIC_API_URL}/api/placeSearch?pageType=${pageType}&searchText=${encodeURIComponent(searchText)}&country=${country}`
      : `${process.env.NEXT_PUBLIC_API_URL}/api/placeSearch?searchText=${encodeURIComponent(searchText)}`;

    const response = await fetch(url, { method: 'GET' });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    let data;
    try {
      data = await response.json();
    } catch (jsonError) {
      throw new Error("Invalid JSON response");
    }

    if (!Array.isArray(data)) {
      throw new Error("Invalid data format received");
    }
     //console.log("DATA",data)
    const places = data.map((result) => ({
      address: result.description,
      placeId: result.place_id,
      state: result.state,
      stateFull: result.stateFull,
    }));

    return places;
  } catch (error) {
    console.error("Something went wrong:", error);
    return []; // Return an empty array on failure
  }
}
